import { Component, OnInit } from '@angular/core';
import { NotificacionCaseta, Turno } from 'src/app/models/dash';
import { NotificacionesPushService } from 'src/app/services/notificaciones-push.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../state/app.state';
import { getTurno } from 'src/app/utils';
import { selectUser } from 'src/app/state/selectors/user.selectors';
import { WebsocketService } from '../../services/websocket.service';
import { TYPE_NOTIFICATION } from '../../utils/enum';
import { ToastrService } from 'ngx-toastr';
import { EventoService } from 'src/app/services/evento.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BitacoraService } from 'src/app/services/bitacora.service';


@Component({
  selector: 'app-home-dashboard',
  templateUrl: './home-dashboard.component.html',
  styleUrls: ['./home-dashboard.component.scss']
})
export class HomeDashboardComponent implements OnInit {

  notificaciones: NotificacionCaseta[] = [];

  fallas: any[] = [];
  usuario: any;
  id_fondo: number;
  turnoActual: Turno;
  openTab = 1;
  notificacion_tipo = [
    { tipo: 'DEVOLUCION', ruta: '/dashboard/devolucion' },
    { tipo: 'RETIRO', ruta: '/dashboard/home' },
    { tipo: 'MORRALLA', ruta: '/dashboard/morralla-carril' },
    { tipo: 'ROLLO', ruta: '/dashboard/morralla-carril' },
  ]
  confirmModal: boolean = false;
  fallaTemp: any = [];

  SECONDS_TO_SYNC: number = 1000;
  polling: any;
  //bitacora
  formBusquedaP: FormGroup;
  formSaveBiatacora: FormGroup;
  bitacoras: any
  bitacorasTemp: any
  constructor(
    private notificacionCaseta: NotificacionesPushService,
    private store: Store<AppState>,
    private socketsService: WebsocketService,
    private eventoService: EventoService,
    private bitacoraService: BitacoraService,
    private toastr: ToastrService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private formBuilder: FormBuilder,

  ) { }

  ngOnInit(): void {
    // Obtener turno actual
    this.turnoActual = getTurno();

    // Obtener el usuario
    this.store.select(selectUser).subscribe(usuario => {
      this.usuario = usuario;

      this.id_fondo = this.usuario.caseta_usuario[0].id_fondo;
    });

    this.createForms()
    this.getBitacoras()
    this.pollData();

  }

  ngOnDestroy() {
    clearInterval(this.polling);
  }


  pollData() {
    this.polling = setInterval(() => {
      console.log('SINCRONIZANDO');
      this.syncNotificacion();
      this.syncFalla();
    }, this.SECONDS_TO_SYNC * 5);
  }

  syncNotificacion() {
    this.notificacionCaseta.getNotificacionCaseta(this.turnoActual.id, this.usuario.id).subscribe(notificacionCaseta => {
      this.notificaciones = notificacionCaseta;
      console.log(this.notificaciones);
    });
  }

  syncFalla() {
    this.eventoService.getEventoFalla(this.id_fondo).subscribe(fallas => {
      this.fallas = fallas;
    });
  }

  sendNotification(tipo) {
    if (TYPE_NOTIFICATION.MORRALLA) {
      //se emite la notificacion para todos los carriles activos
      this.socketsService.emitEvent({ message: '¿Alguién necesita morralla?' });
      this.toastr.success('Se ha enviado la notificación', '', { positionClass: 'toast-bottom-right' })
    }

  }

  atenderFalla() {
    this.ngxUiLoaderService.start()
    this.eventoService.updateEventoFalla(this.fallaTemp)
      .subscribe(data => {
        this.toastr.success('Se atendido la falla', '', { positionClass: 'toast-bottom-right' })
        this.confirmModal = false
        this.ngxUiLoaderService.stop()

      })
  }

  saveTempFalla(falla) {
    this.fallaTemp = falla;
  }

  getBitacoras() {
    this.bitacoraService.getBitacoras()
    .subscribe(bitacoras=>{
      this.bitacoras = bitacoras;
    })

  }

  saveBitacora() {
    console.log(this.formSaveBiatacora.value);
    if (!this.formSaveBiatacora.valid) {
      return this.toastr.info('Ingese la nota de la bitacora', '', { positionClass: 'toast-bottom-right' })
    }
    this.ngxUiLoaderService.start()
    this.bitacoraService.saveBitacora(this.formSaveBiatacora.value)
      .subscribe(nota => {
        this.toastr.success('Bitacora guardada con éxito', '', { positionClass: 'toast-bottom-right' })
        this.ngxUiLoaderService.stop()
        this.formSaveBiatacora.controls['observacion'].setValue(null)

        this.getBitacoras();
      })
  }

  buscadorBitacora() {
    this.ngxUiLoaderService.start()

    this.bitacoraService.busquedaBitacora(this.formBusquedaP.value)
    .subscribe(nota => {
      this.bitacoras = nota;
    this.ngxUiLoaderService.stop()

    })

  }

  createForms() {
    this.formBusquedaP = this.formBuilder.group({
      fecha: ['', Validators.required],
      observacion: ['', Validators.required]

    });

    this.formSaveBiatacora = this.formBuilder.group({
      id_caseta: [this.usuario.caseta_usuario[0].id, Validators.required],
      id_usuario: [this.usuario.id, Validators.required],
      id_turno: [this.turnoActual.id, Validators.required],
      observacion: ['', Validators.required]

    });
  }
  toggleTabs($tabNumber: number){
    this.openTab = $tabNumber;
  }
}
